import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de470bb10599dc/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/link.js");
